import * as React from "react";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import DataObjectIcon from "@mui/icons-material/DataObject";

import { formatDate } from "../../../../utils/misc";

import moment from "moment";

import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  colors,
  Paper,
  IconButton,
  TextField
} from "@mui/material";

function ActivityLogRow(props) {
  const { row, handleActionShowData } = props;

  //console.log("[DEBUG] ActivityLogRow row", row);

  return (
    <TableRow key={row._id} id={row._id}>
      <TableCell align="left">
        {moment
          .utc(row.timestamp)
          .local()
          //.format("hh:mm:ss.SSSa MMM-DD, YYYY Z")}
          .format("hh:mma MMM-DD, YYYY Z")}
      </TableCell>
      <TableCell align="left">{row.kioskID}</TableCell>
      <TableCell align="left">{row.event}</TableCell>
      <TableCell align="center">
        {row.data.bagtagID && (
          <>
            {/* <Button href={`/dashboard/BagtagLogs/${syncErrorRef}?${params.toString()}`}>View Bagtags</Button> */}
            <Button
              //size="small"
              variant="outlined"
              href={`/dashboard/BagtagLogs?bagtagID=${row.data.bagtagID}`}
              target="_blank"
              rel="noopener noreferrer"
              title="View bagtags"
            >
              {row.data.numBags && (
                <div
                  style={{
                    marginRight: "2px"
                  }}
                >
                  {row.data.numBags.toString()}
                </div>
              )}{" "}
              <LabelOutlinedIcon />
            </Button>
          </>
        )}
        {row.data.customerId && <>Customer: {row.data.customerId}</>}
      </TableCell>
    </TableRow>
  );
}

export default ActivityLogRow;
